import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  CREATE_METAS_INIT,
  UPDATE_META_INIT,
  META_LIST_METAS_INIT,
  META_DELETE_META_INIT,
  META_OBTEM_META_INIT
} from '../actionTypes';
import {
  createMetasSucess,
  updateMetaSuccess,
  metaErrorMsg,
  metaListMetasSuccess,
  metaDeleteMetaSuccess,
  obtemMetaSuccess
} from './actions';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { IMeta } from 'src/integracoes/servicos/mongo-atlas/modelos/IMeta';
import { atualizarMeta, criarMeta, deletarMeta, listarMeta, listarMetas } from 'src/integracoes/servicos/mongo-atlas/funcoes/metas';

interface FetchListaMetasResult {
  isError: boolean;
  metas: IMeta[] | null;
  errorMessage: string | null;
}

interface FetchMetaResult {
  isError: boolean;
  meta: IMeta | null;
  errorMessage: string | null;
}

/* ------------------Lista metas empresa---------------- */
export const fetchListarMetas = async (empId: string): Promise<FetchListaMetasResult> => {
  try {
    const { status, dados, mensagem } = await listarMetas(empId);

    if (status && Array.isArray(dados)) {
      return {
        isError: !status,
        metas: dados,
        errorMessage: mensagem,
      };
    }

    return {
      isError: true,
      metas: [],
      errorMessage: mensagem,
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarMetas({ payload }: { payload: { empId: string }; type: any }) {
  const { empId } = payload;
  try {
    const result: FetchListaMetasResult = yield call(fetchListarMetas, empId);

    if (!result.isError) {
      yield put(metaListMetasSuccess({ metas: result.metas }));
    } else {
      yield put(metaErrorMsg({ msg: result.errorMessage }));
    }
  } catch (error: any) {
    yield put(metaErrorMsg({ msg: error.mensagem }));
  }
}

export function* watchListarMetas() {
  yield takeEvery(META_LIST_METAS_INIT, parseListarMetas);
}

/* ------------------Lista meta Id ---------------- */
export const fetchListarMetaId = async (id: string): Promise<FetchMetaResult> => {
  try {
    const { status, dados, mensagem } = await listarMeta(id);

    if (status) {
      return {
        isError: !status,
        meta: dados as IMeta,
        errorMessage: mensagem,
      };
    }

    return {
      isError: true,
      meta: null,
      errorMessage: mensagem,
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarMetaId({ payload }: { payload: { id: string }; type: any }) {
  const { id } = payload;
  try {
    const { isError, errorMessage, meta }: FetchMetaResult = yield call(fetchListarMetaId, id);
    if (!isError) {
      yield put(obtemMetaSuccess({ meta: meta }));
    } else {
      yield put(metaErrorMsg({ msg: errorMessage }));
    }
  } catch (error: any) {
    yield put(metaErrorMsg({ msg: error.mensagem }));
  }
}

export function* watchListarMetaId() {
  yield takeEvery(META_OBTEM_META_INIT, parseListarMetaId);
}


/* ------------------Criar meta ---------------- */
export const fetchCriarMeta = async (meta: any) => {
  try {
    const { status, dados, mensagem } = await criarMeta(meta);
    if (status) {
      return {
        isCreated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isCreated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCriarMeta({ payload }: { payload: any, type: any }) {
  const { meta } = payload;

  try {
    const { isCreated, msg, data } = yield call(fetchCriarMeta, meta);
    if (isCreated) {
      yield put(createMetasSucess({ current: data, msg: msg }));
    } else {
      yield put(metaErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      metaErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchCriarMeta() {
  yield takeEvery(CREATE_METAS_INIT, parseCriarMeta);
}

/* ------------------Atualiza meta ---------------- */
export const fetchAtualizarMeta = async (id: string, meta: any) => {
  try {
    const { status, dados, mensagem } = await atualizarMeta(id, meta);
    if (status) {
      return {
        isUpdated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isUpdated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizarMeta({ payload }: { payload: any; type: any }) {
  const { id, meta } = payload;

  try {
    const { isUpdated, msg } = yield call(fetchAtualizarMeta, id, meta);

    if (isUpdated) {
      yield put(updateMetaSuccess({ msg }));
    } else {
      yield put(metaErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(

      metaErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchAtualizarMeta() {
  yield takeEvery(UPDATE_META_INIT, parseAtualizarMeta);
}

/* ------------------Deletar meta ---------------- */
export const fetchDeletarMeta = async (id: string) => {
  try {
    const { status, mensagem } = await deletarMeta(id);
    if (status) {
      return { isUpdated: true, msg: mensagem };
    } else {
      return {
        isUpdated: false,
        msg: mensagem
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseDeletarMeta({ payload }: { payload: any; type: any }) {
  const { id } = payload;
  try {
    const { isUpdated, msg } = yield call(fetchDeletarMeta, id);

    if (isUpdated) {
      yield put(metaDeleteMetaSuccess({ id, msg }));
    } else {
      yield put(metaErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      metaErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchDeletarMeta() {
  yield takeEvery(META_DELETE_META_INIT, parseDeletarMeta);
}

// WATCHS
export default function* rootSaga() {
  yield all([
    fork(watchListarMetas),
    fork(watchListarMetaId),
    fork(watchCriarMeta),
    fork(watchAtualizarMeta),
    fork(watchDeletarMeta)
  ]);
}
